module.exports = __webpack_public_path__ + "img/Frame-10.ae358594.png";